import { ApiResponse, DepartmentResponse } from "./interface";
import { axiosInstanceAuth } from "./setup";

export const handleGetDepartments = async (): Promise<DepartmentResponse[]> => {
  const result = await axiosInstanceAuth().get<ApiResponse>(`/admin/fetch_departments`);
  return result.data.data as DepartmentResponse[];
};

export const handleDepartmentsByCompanyApi = async (
  companyId: number
): Promise<DepartmentResponse[]> => {
  const result = await axiosInstanceAuth().get<ApiResponse>(`/admin/department_by_company?companyId=${companyId}`);
  return result.data.data as DepartmentResponse[];
};
